import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../Icon/Icon';
import styles from './Footer.module.css';
// Importar animaciones globales
import '../../styles/animations.module.css';

/**
 * Footer Component - TECNILAND
 * DESKTOP-FIRST: Animaciones optimizadas para 1920px+
 * Sin hacks - CSS puro con CSS Modules
 */
function Footer() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const handleSmoothScroll = (e, anchor) => {
    e.preventDefault();
    
    // Si no estamos en home, navegar primero a home
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(anchor);
        if (element) {
          const navbarHeight = 80;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navbarHeight;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.querySelector(anchor);
      if (element) {
        const navbarHeight = 80;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - navbarHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const handleServerClick = (e) => {
    e.preventDefault();
    navigate('/server');
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Sección 1: Branding */}
        <div className={`${styles.footerSection} ${styles.branding}`}>
          <div className={styles.footerLogo}>
            <span className={styles.logoText} translate="no">TECNILAND</span>
            <span className={styles.logoIcon}>◆</span>
          </div>
          <p className={styles.footerTagline}>
            Un multiverso donde la creatividad y la tecnología convergen.
          </p>
        </div>

        {/* Sección 2: Navegación */}
        <div className={styles.footerSection}>
          <h4>Navegación</h4>
          <ul>
            <li><a href="#hero" onClick={(e) => handleSmoothScroll(e, '#hero')}>Home</a></li>
            <li><a href="#features" onClick={(e) => handleSmoothScroll(e, '#features')}>Características</a></li>
            <li><a href="#modpacks" onClick={(e) => handleSmoothScroll(e, '#modpacks')}>Modpacks</a></li>
            <li><a href="#lore" onClick={(e) => handleSmoothScroll(e, '#lore')}>Lore</a></li>
            <li><a href="/server" onClick={handleServerClick}>Servidor</a></li>
          </ul>
        </div>

        {/* Sección 3: Recursos */}
        <div className={styles.footerSection}>
          <h4>Recursos</h4>
          <ul>
            <li><a href="#roadmap" onClick={(e) => handleSmoothScroll(e, '#roadmap')}>Roadmap</a></li>
            <li><a href="#gallery" onClick={(e) => handleSmoothScroll(e, '#gallery')}>Galería</a></li>
            <li><a href="#contact" onClick={(e) => handleSmoothScroll(e, '#contact')}>Contacto</a></li>
          </ul>
        </div>

        {/* Sección 4: Comunidad */}
        <div className={styles.footerSection}>
          <h4>Comunidad</h4>
          <div className={styles.socialIcons}>
            <a href="https://discord.gg/Nd5sw8DUgZ" target="_blank" rel="noopener noreferrer" title="Discord" className={styles.socialIcon}>
              <Icon name="discord" size="md" animation="float" />
            </a>
            <a href="https://github.com/Ppkeash" target="_blank" rel="noopener noreferrer" title="GitHub" className={styles.socialIcon}>
              <Icon name="github" size="md" animation="float" />
            </a>
            <a href="https://twitter.com/UniLekConz" target="_blank" rel="noopener noreferrer" title="Twitter" className={styles.socialIcon}>
              <Icon name="twitter" size="md" animation="float" />
            </a>
            <a href="https://www.youtube.com/@lil_kysh/videos" target="_blank" rel="noopener noreferrer" title="YouTube" className={styles.socialIcon}>
              <Icon name="youtube" size="md" animation="float" />
            </a>
            <a href="mailto:tutosmaspros@gmail.com" title="Email" className={styles.socialIcon}>
              <Icon name="email" size="md" animation="float" />
            </a>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className={styles.footerDivider}></div>

      {/* Bottom Section */}
      <div className={styles.footerBottom}>
        <div className={styles.footerBottomContent}>
          <p className={styles.copyright}>
            © {currentYear} <span translate="no" className="notranslate">TECNILAND</span>. Creado con ❤️ y <span className={styles.highlight}>∞</span> posibilidades.
          </p>
          <div className={styles.footerMeta}>
            <a href="/privacy">Privacidad</a>
            <span className={styles.separator}>•</span>
            <a href="/terms">Términos</a>
            <span className={styles.separator}>•</span>
            <span className={styles.version}>v1.0.0</span>
          </div>
        </div>
      </div>

      {/* Easter Egg */}
      <div className={styles.easterEgg}>
        <p>🌌 "Devuelta a <span translate="no" className="notranslate">TECNILAND</span>" 🌌</p>
      </div>
    </footer>
  );
}

export default Footer;
